var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-container",
    { staticClass: "bv-example-row" },
    [
      _c("Header"),
      _vm._v(" "),
      _c(
        "b-row",
        [_c("b-col", { staticClass: "hr", attrs: { cols: "12" } })],
        1
      ),
      _vm._v(" "),
      _c(
        "b-row",
        [
          _c("b-col", { attrs: { cols: "3" } }, [_c("Menu")], 1),
          _vm._v(" "),
          _c(
            "b-col",
            { staticClass: "border", attrs: { cols: "9" } },
            [
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    { attrs: { cols: "12" } },
                    [
                      _c(
                        "b-row",
                        [
                          _c(
                            "b-col",
                            { attrs: { cols: "12" } },
                            [
                              _c(
                                "b-row",
                                [
                                  _c(
                                    "b-col",
                                    {
                                      staticClass: "head",
                                      attrs: { cols: "12" }
                                    },
                                    [_c("h4", [_vm._v(":: Oficinas")])]
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "b-row",
                                [
                                  _c(
                                    "b-col",
                                    {
                                      staticClass: "breadcrumb",
                                      attrs: { cols: "12" }
                                    },
                                    [
                                      _c(
                                        "b-link",
                                        {
                                          attrs: {
                                            to: { name: "SupervisorOffices" }
                                          }
                                        },
                                        [_vm._v("Oficinas")]
                                      ),
                                      _vm._v("» Editar:\n                    ")
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c("div", { staticClass: "mt-2" }),
                              _vm._v(" "),
                              _c(
                                "b-form",
                                {
                                  staticClass: "pb-4",
                                  on: { submit: _vm.onSubmit }
                                },
                                [
                                  _c(
                                    "b-form-group",
                                    {
                                      attrs: {
                                        id: "f_name",
                                        horizontal: "",
                                        "label-cols": 4,
                                        breakpoint: "md",
                                        label: "Nombre"
                                      }
                                    },
                                    [
                                      _c("b-form-input", {
                                        attrs: { id: "name", state: _vm.state },
                                        model: {
                                          value: _vm.office.name,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.office,
                                              "name",
                                              typeof $$v === "string"
                                                ? $$v.trim()
                                                : $$v
                                            )
                                          },
                                          expression: "office.name"
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "b-form-group",
                                    {
                                      attrs: {
                                        id: "f_address",
                                        horizontal: "",
                                        "label-cols": 4,
                                        breakpoint: "md",
                                        label: "Dirección"
                                      }
                                    },
                                    [
                                      _c("b-form-input", {
                                        attrs: {
                                          id: "address",
                                          state: _vm.state
                                        },
                                        model: {
                                          value: _vm.office.address,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.office,
                                              "address",
                                              typeof $$v === "string"
                                                ? $$v.trim()
                                                : $$v
                                            )
                                          },
                                          expression: "office.address"
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "b-form-group",
                                    {
                                      attrs: {
                                        id: "f_phone",
                                        horizontal: "",
                                        "label-cols": 4,
                                        breakpoint: "md",
                                        label: "Teléfono"
                                      }
                                    },
                                    [
                                      _c("b-form-input", {
                                        attrs: {
                                          id: "phone",
                                          state: _vm.state
                                        },
                                        model: {
                                          value: _vm.office.phone,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.office,
                                              "phone",
                                              typeof $$v === "string"
                                                ? $$v.trim()
                                                : $$v
                                            )
                                          },
                                          expression: "office.phone"
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "b-form-group",
                                    {
                                      attrs: {
                                        id: "f_department",
                                        horizontal: "",
                                        "label-cols": 4,
                                        breakpoint: "md",
                                        label: "Departamento"
                                      }
                                    },
                                    [
                                      _c("b-form-input", {
                                        attrs: {
                                          id: "department",
                                          state: _vm.state
                                        },
                                        model: {
                                          value: _vm.office.department,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.office,
                                              "department",
                                              typeof $$v === "string"
                                                ? $$v.trim()
                                                : $$v
                                            )
                                          },
                                          expression: "office.department"
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "b-form-group",
                                    {
                                      attrs: {
                                        id: "f_district",
                                        horizontal: "",
                                        "label-cols": 4,
                                        breakpoint: "md",
                                        label: "Distrito"
                                      }
                                    },
                                    [
                                      _c("b-form-input", {
                                        attrs: {
                                          id: "district",
                                          state: _vm.state
                                        },
                                        model: {
                                          value: _vm.office.department,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.office,
                                              "department",
                                              typeof $$v === "string"
                                                ? $$v.trim()
                                                : $$v
                                            )
                                          },
                                          expression: "office.department"
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "b-form-group",
                                    {
                                      attrs: {
                                        id: "f_codigosap",
                                        horizontal: "",
                                        "label-cols": 4,
                                        breakpoint: "md",
                                        label: "Departamento"
                                      }
                                    },
                                    [
                                      _c("b-form-input", {
                                        attrs: {
                                          id: "department",
                                          state: _vm.state
                                        },
                                        model: {
                                          value: _vm.office.department,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.office,
                                              "department",
                                              typeof $$v === "string"
                                                ? $$v.trim()
                                                : $$v
                                            )
                                          },
                                          expression: "office.department"
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "b-form-group",
                                    {
                                      attrs: {
                                        id: "f_status",
                                        horizontal: "",
                                        "label-cols": 4,
                                        breakpoint: "md",
                                        label: "Código SAP"
                                      }
                                    },
                                    [
                                      _c("b-form-input", {
                                        attrs: {
                                          id: "status",
                                          state: _vm.state
                                        },
                                        model: {
                                          value: _vm.office.codigo_sap,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.office,
                                              "codigo_sap",
                                              typeof $$v === "string"
                                                ? $$v.trim()
                                                : $$v
                                            )
                                          },
                                          expression: "office.codigo_sap"
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "b-button",
                                    {
                                      attrs: {
                                        type: "submit",
                                        variant: "primary derco"
                                      }
                                    },
                                    [_vm._v("Actualizar")]
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2b6dbfe6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2b6dbfe6","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Supervisor/EditOffice.vue
// module id = null
// module chunks = 